import React from 'react';
import { Page } from '../Page';
export function DividerSupplements() {
  return <Page hideFooter variant="dark" data-id="element-657" data-mp="1nmvkfmlbt9dq">
      <div className="flex flex-col h-full justify-center items-center text-center" data-id="element-658" data-mp="1nnyajsatr7sl">
        <p className="text-[10px] font-bold text-lightteal uppercase tracking-[0.25em] mb-4" data-id="element-659" data-mp="22bro77gco08j">
          Part Four
        </p>
        <h1 className="text-5xl font-serif text-white leading-tight mb-6" data-id="element-660" data-mp="1xj8eilks9p90">
          Supplements
        </h1>
        <div className="w-16 h-0.5 bg-tealslate" data-id="element-661" data-mp="2bad6r2ltnf9b" />
      </div>
    </Page>;
}